import { Nullable } from '@clearverify/types';

import { VerifierCredentialStatus } from 'src/api';

export enum VerifyManuallyModalFields {
  status = 'status',
  denialReason = 'denialReason',
  permissiblePurposeReference = 'permissiblePurposeReference',
}

export type VerifyManuallyModalValues = {
  [VerifyManuallyModalFields.status]: VerifierCredentialStatus;
  [VerifyManuallyModalFields.denialReason]: Nullable<string>;
  [VerifyManuallyModalFields.permissiblePurposeReference]: Nullable<string>;
};
